import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppDispatch } from '../../redux-store'

export interface ThemeActionTypes {
    theme: string,
    themeId: string
}

interface InitialStateTypes {
    theme: string,
    themeId: string,
    update: boolean,
}

let initialState: InitialStateTypes = {
    theme: 'dark',
    themeId: '1',
    update: true,
}

export const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setUpdate(state, action: PayloadAction<boolean>) {
            state.update = action.payload
        },
        setTheme(state, action: PayloadAction<ThemeActionTypes>) {
            state.update = false
            state.theme = action.payload.theme
            state.themeId = action.payload.themeId
        }
    }
})

export const setUpdate = (update: boolean) => async (dispatch: AppDispatch) => {
    dispatch(themeSlice.actions.setUpdate(update))
}

export const setTheme = (theme: string, themeId: string) => async (dispatch: AppDispatch) => {
    dispatch(themeSlice.actions.setTheme({theme, themeId}))
}

export default themeSlice.reducer